const formatServerError = (response, message = 'An error has occurred') => {
  const errorResponseTemplate = {
    originalMessage: '',
    error: {
      errors: [{ message }],
    },
  };

  if (typeof response.data === 'string') {
    errorResponseTemplate.originalMessage = response.data;
    // eslint-disable-next-line no-param-reassign
    response.data = errorResponseTemplate;
  }
};

export default {
  formatServerError,
};
